import React, { useState, useContext } from 'react';
import { IonPage, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent, IonList, IonItem, IonLabel, IonInput, IonButton, IonToast, IonLoading } from '@ionic/react';
import { withRouter } from 'react-router';

import './Login.css';
import { FirebaseContext } from '../services/Firebase';

interface RegisterProps {
  history: any
}

const Register: React.FC<RegisterProps> = ({ history }) => {
  const [name, setName] = useState('');  
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const isInvalid = pwd === '' || email === '' || name === '' || pwd !== pwd2;
  const firebase = useContext(FirebaseContext);
  
  const handleRegister = (e: any) => {    
    e.preventDefault();
    setLoading(true);
    firebase
    .createUserWithEmailAndPassword(email, pwd, name)
    .then(() => {
      setLoading(false);
      history.go(-2)
    })
    .catch((error: any) => {
      setLoading(false);
      setError(error);
    })
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons>
            <IonBackButton defaultHref='/home' />
          </IonButtons>
          <IonTitle>Inscription</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding ion-text-center">
        <IonLoading isOpen={loading} />
        <IonToast
          isOpen={!!error}
          message={(error || { message: 'Oups, une erreure s\'produite...'}).message}
          duration={8000}
          color="danger"
        />
        <img src='/assets/icon/icon.png' alt='qualiocoach' className='illustration-login ion-margin-top' />
        <IonList>
          <IonItem>
            <IonLabel position="stacked">
              Nom
            </IonLabel>
            <IonInput type="text" value={name} onIonChange={({ detail: { value }}) => setName(value || '')}/>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Email
            </IonLabel>
            <IonInput type="text" value={email} onIonChange={({ detail: { value }}) => setEmail(value || '')}/>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Mot de passe
            </IonLabel>
            <IonInput type="password" value={pwd} onIonChange={({ detail: { value }}) => setPwd(value || '')}/>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Confirmation du mot de passe
            </IonLabel>
            <IonInput type="password" value={pwd2} onIonChange={({ detail: { value }}) => setPwd2(value || '')}/>
          </IonItem>
        </IonList>
        <div className="ion-padding">
          <IonButton
            expand="block"
            className='ion-no-margin ion-margin-top'
            disabled={isInvalid}
            onClick={handleRegister}
          >
            S'inscrire
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(Register);
